import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'reboron/DropModal'
import { FormattedMessage } from 'react-intl'

import QuestIcon from '../../../mini/QuestIcon'

import { cancel, ok } from '../../../../utils/messages'

export default class ToQualityReviewModal extends Component {
  constructor(props) {
    super(props)
    this.handleCancelClickBound = this.handleCancelClick.bind(this)
    this.handleConfirmClickBound = this.handleConfirmClick.bind(this)
    this.handleHideBound = this.handleHide.bind(this)
  }
  componentDidMount() {
    this.showModal()
  }

  render() {
    const modalStyle = {
      maxHeight: 'calc(100% - 100px)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      minWidth: '400px',
      background: '#fff',
      overflow: 'scroll',
      borderRadius: '6px',
      width: '400px'
    }

    const contentStyle = {
      backgroundColor: '#fff',
      height: '100%'
    }
    const { quest, isSettingLastApproval } = this.props
    return (
      <Modal
        ref="modal"
        className={'review-modal'}
        modalStyle={modalStyle}
        contentStyle={contentStyle}
        closeOnClick={false}
        onHide={this.handleHideBound}
      >
        <div>
          <div className="modal-heading">
            <QuestIcon heightWidth={54} icon_image_url={quest.icon_image_url} />
            <h3>
              <FormattedMessage
                id={'ToQualityReviewModal.Next:QualityReview'}
                defaultMessage={'Next: Publication Review'}
              />
            </h3>
          </div>
          <div className="modal-body">
            <div className="modal-body-text">
              <FormattedMessage
                id={'ToQualityReviewModal.InternalReviewsAreDone'}
                defaultMessage={
                  'Internal reviews are done! Your review was the last one needed from your organization. Now, the quest will move on to Publication Review.'
                }
              />
            </div>
            <div className="actions">
              <div
                className={`button modal-cancel ${
                  isSettingLastApproval ? 'disabled' : ''
                }`}
                onClick={this.handleCancelClickBound}
              >
                {cancel}
              </div>
              <div
                className={`button modal-confirm ${
                  isSettingLastApproval ? 'disabled' : ''
                }`}
                onClick={this.handleConfirmClickBound}
              >
                {ok}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  handleCancelClick() {
    this.props.handleCancelClick()
  }

  handleConfirmClick() {
    this.props.handleConfirmClick(this.props.criteria)
  }

  showModal() {
    this.refs.modal.show()
  }

  handleHide() {
    this.props.handleCancelClick()
  }
}

ToQualityReviewModal.propTypes = {
  quest: PropTypes.object.isRequired,
  handleCancelClick: PropTypes.func.isRequired,
  handleConfirmClick: PropTypes.func.isRequired,
  criteria: PropTypes.string.isRequired,
  isSettingLastApproval: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/review/internalreview/ToQualityReviewModal.js